// color-exempt-file — retokenisation 5728fe509 : classes dark:bg-[#hex] ajoutees pour preserver le rendu dark historique (voir memoire ui-themes)
import React from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Question } from "@core/components/polls/QuestionCard";

export type QuestionListNavProps = {
  questions: Question[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onAdd?: () => void;
  modifiedQuestionId?: string | null;
};

export default function QuestionListNav({
  questions,
  activeId,
  onSelect,
  onAdd,
  modifiedQuestionId,
}: QuestionListNavProps) {
  const { t } = useTranslation("forms");
  return (
    <div className="flex flex-wrap items-center gap-2">
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          title={t("nav.addQuestion.title")}
          data-testid="nav-add-question"
        >
          <Plus size={18} />
        </button>
      )}
      {questions.map((q, idx) => (
        <button
          key={q.id}
          type="button"
          aria-current={activeId === q.id}
          onClick={() => onSelect(q.id)}
          className={
            "rounded-full px-3 py-1 text-sm transition-all duration-300 " +
            (modifiedQuestionId === q.id
              ? "bg-success text-success-foreground animate-pulse"
              : activeId === q.id
                ? "bg-primary text-primary-foreground"
                : "bg-muted dark:bg-[#3c4043] text-muted-foreground hover:bg-accent")
          }
          title={q.title || `Q${idx + 1}`}
          data-testid="question-nav"
          data-qid={q.id}
          data-index={idx + 1}
        >
          {`Q${idx + 1}`}
        </button>
      ))}
    </div>
  );
}
